import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { CreateFundingBatchTransferDrawer } from '../../../../../../features/funding/batch-transfer/funding-batch-transfer-create-drawer';
import { FundingBatchTransfersTable } from '../../../../../../features/funding/batch-transfer/funding-batch-transfers-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/funding/batch-transfer/_batch-transfer/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RollupFunding,
      label: 'Batch Transfers',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RollupFunding>,
  head: () => getPageHead('Batch Transfers'),
  component: FundingBatchTransferList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateFundingBatchTransferDrawer
              trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Batch Transfer" size="small" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RollupFunding}
    />
  );
}

function FundingBatchTransferList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FundingBatchTransfersTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
